import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_CHALLAN_STATS_REQUEST,
  FETCH_CHALLAN_STATS_SUCCESS,
  FETCH_CHALLAN_STATS_FAILURE,
  FETCH_OFFICER_STATS_REQUEST,
  FETCH_OFFICER_STATS_SUCCESS,
  FETCH_OFFICER_STATS_FAILURE,
  FETCH_CHART_DATA_REQUEST,
  FETCH_CHART_DATA_SUCCESS,
  FETCH_CHART_DATA_FAILURE,
} from "../../actions/admin-dashboard/AdminDashboardActions";

const initialState = {
  loading: false,
  dashboardStats: {
    totalSurveyOfficers: 0,
    totalChallans: 0,
    totalPaid: 0,
    totalPending: 0,
    totalCancelled: 0,
    totalFineAmount: 0,
    totalCollectedAmount: 0,
    totalDistricts: 0,
    totalMunicipalities: 0,
    totalWards: 0,
  },
  challanStats: [],
  officerStats: [],
  chartData: {
    monthlyTrend: [],
    paymentStatusDistribution: [],
    offenseDistribution: [],
    districtDistribution: [],
  },
  error: null,
};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
    case FETCH_CHALLAN_STATS_REQUEST:
    case FETCH_OFFICER_STATS_REQUEST:
    case FETCH_CHART_DATA_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardStats: action.payload,
        error: null,
      };

    case FETCH_CHALLAN_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        challanStats: action.payload || [],
        error: null,
      };

    case FETCH_OFFICER_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        officerStats: action.payload || [],
        error: null,
      };

    case FETCH_CHART_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        chartData: action.payload || {
          monthlyTrend: [],
          paymentStatusDistribution: [],
          offenseDistribution: [],
          districtDistribution: [],
        },
        error: null,
      };

    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_CHALLAN_STATS_FAILURE:
    case FETCH_OFFICER_STATS_FAILURE:
    case FETCH_CHART_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default adminDashboardReducer;
